import React, { useEffect, useState } from 'react';
import { Select, Button } from 'antd';
import axios from 'axios';
import { ReloadOutlined } from '@ant-design/icons';

const { Option } = Select;

const FilterBotsUI = ({ onDataSend }) => {
  const [dropdownData, setDropdownData] = useState({
    exchange_type: [],
    exchange: [],
    risk: [],
    botname: [],
    quote_asset: [],
    symbol: [],
  });

  const [selectedFilters, setSelectedFilters] = useState({
    exchange_type: 'ALL',
    exchange: 'ALL',
    risk: 'ALL',
    botname: 'ALL',
    quote_asset: 'ALL',
    symbol: 'ALL',
  });

  const resetFilters = () => {
    setSelectedFilters({
      exchange_type: 'ALL',
      exchange: 'ALL',
      risk: 'ALL',
      botname: 'ALL',
      quote_asset: 'ALL',
      symbol: 'ALL',
    });
  };




  const [loading, setLoading] = useState(true);

  // Fetch the dropdown data on initial load
  useEffect(() => {
    const fetchDropdownData = async () => {
        let jwt  = localStorage.getItem('jwt')
        const postdata = {
            jwt:jwt
        }
       
      try {
        const response = await axios({
            method: "POST",
            headers: { "Content-Type": "application/json" },
            url: process.env.REACT_APP_API + "/bot/view_bot_list_dropdown",
            data: postdata,
          });
        setDropdownData(response.data.Success);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
        setLoading(false);
      }
    };

    fetchDropdownData();
  }, []);

  // Handle dropdown change and trigger the filter API
  const handleSelectChange = (value, key) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters, [key]: value };
      fetchFilteredData(updatedFilters);
      return updatedFilters;
    });
  };

  const fetchFilteredData = async (filters) => {
    setLoading(true);
    let jwt = localStorage.getItem('jwt'); 
    let postdata = { jwt };
  
    // Check each filter and add it to the postdata object if selected
    if (filters.exchange_type && filters.exchange_type !== "ALL") {
      postdata.exchange_type = [filters.exchange_type];
    }
  
    if (filters.exchange && filters.exchange !== "ALL") {
      postdata.exchange = [filters.exchange];
    }
  
    if (filters.risk && filters.risk !== "ALL") {
      postdata.risk = [filters.risk];
    }
  
    if (filters.botname && filters.botname !== "ALL") {
      postdata.botname = [filters.botname];
    }
  
    if (filters.quote_asset && filters.quote_asset !== "ALL") {
      postdata.quote_asset = [filters.quote_asset];
    }
  
    if (filters.symbol && filters.symbol !== "ALL") {
      postdata.symbol = [filters.symbol];
    }
  
    try {
      const response = await axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: process.env.REACT_APP_API + "/bot/view_bot_list_dropdown", // Modify this endpoint if needed
        data: postdata,
      });
  
     
      setDropdownData(response.data.Success); 
     
      setLoading(false);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    onDataSend(selectedFilters);
  }, [selectedFilters])
  
  
  return (
     <div className="m-5 p-6 rounded-xl  shadow-lg">
      <div className="grid grid-cols-2 lg:grid-cols-6 gap-6">
        {['exchange_type', 'exchange', 'risk', 'botname', 'quote_asset', 'symbol'].map((field, index) => (
          <div key={index}>
            <label htmlFor={field} className="block text-black mb-2 font-semibold">
              {field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')}
            </label>
            <Select
              id={field}
              value={selectedFilters[field]}
              onChange={(value) => handleSelectChange(value, field)}
              style={{ width: '100%', borderRadius: '8px' }}
              className="text-lg"
            >
              {dropdownData[field]?.map((item) => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
        ))}
      </div>
      
      <div className="flex justify-end mt-4">
        <Button
       
          onClick={resetFilters}
          icon={<ReloadOutlined />}
          className="bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg"
        >
          Reset Filters
        </Button>
      </div>
    </div>
  
  
  );
};

export default FilterBotsUI;
